import axios from "axios";
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';
import QueueResponse, { WorkerResponse } from "@/models/queue";

const API_QUEUE_URL = process.env.VUE_APP_API_URL+"/queue";
const API_WORKER_URL = process.env.VUE_APP_API_URL+"/workers";

export default class QueueController {
    static async fetchQueueTasksWithSummary() {
        try {
            const response = await axios.get(`${API_QUEUE_URL}/get_queue_tasks_with_summary`);
            console.log("Queue tasks fetched successfully:", response.data);
            return new QueueResponse(response.data);
        }
        catch (error) {
            if (error.response && error.response.status === 503) {
                console.log("Service unavailable, returning empty queue response");
                return { total_tasks: null, per_deadline_summary: null, tasks: null };
            }
            throw error;
        }
    }

    static async fetchWorkerSummary() {
        try {
            const response = await axios.get(`${API_WORKER_URL}/get_worker_summary`);
            console.log("Worker summary fetched successfully:", response.data);
            return new WorkerResponse(response.data);
        }
        catch (error) {
            if (error.response && error.response.status === 503) {
                console.log("Service unavailable, returning empty worker summary");
                return { workers_summaries: null, max_workers: null };
            }
            throw error;
        }
    }

    static async cancelAllQueueTasks() {
        const response = await axios.delete(`${API_QUEUE_URL}/cancel_all_queue_tasks`);
        console.log("All queue tasks canceled successfully:", response.data);
        return response.data;
    }
}

applyErrorHandlers(QueueController);